import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'communities',
  children: {
    id: {
      path: ':id',
    },
    post: {
      path: 'post',
      children: {
        new: {
          path: 'new',
        },
        newEvent: {
          path: 'new-event',
        },
        id: {
          path: ':id',
          children: {
            edit: {
              path: 'edit',
            },
          },
        },
      },
    },
  },
} as const satisfies Location
